"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeCanMakeMove = exports.getAllValidPieceMoves = exports.getIsCheckmate = exports.getIsStalemate = exports.getIsKingInCheck = exports.getIsValidMove = void 0;
const config_1 = require("./config");
const getUpdatedBoardRepresentation = ({ board, boardUpdates, }) => {
    const tempBoard = [...board];
    Object.entries(boardUpdates).forEach(([index, piece]) => {
        tempBoard[Number(index)] = piece;
    });
    return tempBoard;
};
const getPlayerMultiplier = (playerTurn) => (playerTurn === "white" ? -1 : 1);
const getIsDestinationFriendlyFree = ({ playerTurn, board, destination, }) => {
    return playerTurn === "white"
        ? !config_1.whiteSanPieces.includes(board[destination])
        : !config_1.blackSanPieces.includes(board[destination]);
};
const getIsCapturingEnemyPiece = ({ playerTurn, board, destination, }) => {
    const isCapturingEnemyPiece = playerTurn === "white"
        ? config_1.blackSanPieces.includes(board[destination])
        : config_1.whiteSanPieces.includes(board[destination]);
    return isCapturingEnemyPiece && board[destination] !== " ";
};
const getIsDiagonalMove = ({ origin, destination }) => {
    const originRow = Math.floor(origin / config_1.tilesPerRow);
    const originCol = origin % config_1.tilesPerRow;
    const destRow = Math.floor(destination / config_1.tilesPerRow);
    const destCol = destination % config_1.tilesPerRow;
    const rowDiff = Math.abs(destRow - originRow);
    const colDiff = Math.abs(destCol - originCol);
    return rowDiff === colDiff;
};
const getIsDiagonalClear = ({ board, origin, destination, }) => {
    let direction = null;
    if (origin < destination && (destination - origin) % (config_1.tilesPerRow - 1) === 0) {
        direction = "down-left";
    }
    else if (origin > destination && (destination - origin) % (config_1.tilesPerRow - 1) === 0) {
        direction = "up-right";
    }
    else if (origin < destination && (destination - origin) % (config_1.tilesPerRow + 1) === 0) {
        direction = "down-right";
    }
    else if (origin > destination && (destination - origin) % (config_1.tilesPerRow + 1) === 0) {
        direction = "up-left";
    }
    if (direction === null) {
        return false;
    }
    let current = origin;
    while (current !== destination) {
        if (direction === "up-left") {
            current -= config_1.tilesPerRow + 1;
        }
        else if (direction === "up-right") {
            current -= config_1.tilesPerRow - 1;
        }
        else if (direction === "down-left") {
            current += config_1.tilesPerRow - 1;
        }
        else if (direction === "down-right") {
            current += config_1.tilesPerRow + 1;
        }
        if (board[current] !== " " && current !== origin && current !== destination) {
            return false;
        }
    }
    return true;
};
const getIsStraightMove = ({ origin, destination }) => {
    const rowDifference = Math.abs(Math.floor(destination / config_1.tilesPerRow) - Math.floor(origin / config_1.tilesPerRow));
    const colDifference = Math.abs((destination % config_1.tilesPerRow) - (origin % config_1.tilesPerRow));
    return (rowDifference > 0 && colDifference === 0) || (rowDifference === 0 && colDifference > 0);
};
const getIsStraightClear = ({ board, origin, destination, }) => {
    const rowStart = Math.floor(origin / config_1.tilesPerRow);
    const colStart = origin % config_1.tilesPerRow;
    const rowEnd = Math.floor(destination / config_1.tilesPerRow);
    const colEnd = destination % config_1.tilesPerRow;
    if (rowStart === rowEnd) {
        // horizontal move
        const start = Math.min(colStart, colEnd);
        const end = Math.max(colStart, colEnd);
        for (let col = start + 1; col < end; col++) {
            const position = rowStart * config_1.tilesPerRow + col;
            if (board[position] !== " ") {
                return false;
            }
        }
    }
    else if (colStart === colEnd) {
        // vertical move
        const start = Math.min(rowStart, rowEnd);
        const end = Math.max(rowStart, rowEnd);
        for (let row = start + 1; row < end; row++) {
            const position = row * config_1.tilesPerRow + colStart;
            if (board[position] !== " ") {
                return false;
            }
        }
    }
    else {
        // invalid move (not horizontal or vertical)
        return false;
    }
    return true;
};
const getCanCastle = (props) => {
    const { playerTurn, board, origin, destination, whiteKingHasMoved, whiteRightRookHasMoved, whiteLeftRookHasMoved, blackKingHasMoved, blackRightRookHasMoved, blackLeftRookHasMoved, } = props;
    let canCastle = false;
    if (playerTurn === "white") {
        if (origin === 60 &&
            destination === 62 &&
            !whiteKingHasMoved &&
            !whiteRightRookHasMoved &&
            board[61] === " " &&
            board[62] === " " &&
            !getIsKingInCheck(props) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 60: " ", 61: "K" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 60: " ", 61: " ", 62: "K" },
                }) }))) {
            canCastle = true;
        }
        else if (origin === 60 &&
            destination === 58 &&
            !whiteKingHasMoved &&
            !whiteLeftRookHasMoved &&
            board[59] === " " &&
            board[58] === " " &&
            board[57] === " " &&
            !getIsKingInCheck(props) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 60: " ", 59: "K" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 60: " ", 59: " ", 58: "K" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 60: " ", 59: " ", 58: " ", 57: "K" },
                }) }))) {
            canCastle = true;
        }
    }
    else if (playerTurn === "black") {
        if (origin === 4 &&
            destination === 6 &&
            !blackKingHasMoved &&
            !blackLeftRookHasMoved &&
            board[5] === " " &&
            board[6] === " " &&
            !getIsKingInCheck(props) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 4: " ", 5: "k" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 4: " ", 5: " ", 6: "k" },
                }) }))) {
            canCastle = true;
        }
        else if (origin === 4 &&
            destination === 2 &&
            !blackKingHasMoved &&
            !blackRightRookHasMoved &&
            board[3] === " " &&
            board[2] === " " &&
            board[1] === " " &&
            !getIsKingInCheck(props) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 4: " ", 3: "k" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 4: " ", 3: " ", 2: "k" },
                }) })) &&
            !getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({
                    board,
                    boardUpdates: { 4: " ", 3: " ", 2: " ", 1: "k" },
                }) }))) {
            canCastle = true;
        }
    }
    return canCastle;
};
const getCanPawnPromote = (props) => {
    const { playerTurn, origin, destination } = props;
    const multiplier = getPlayerMultiplier(playerTurn);
    const isPromotionRow = playerTurn === "white" ? 0 : 7;
    return origin + multiplier * config_1.tilesPerRow === destination && Math.floor(destination / config_1.tilesPerRow) === isPromotionRow;
};
const getIsValidPawnMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false, canSetEnPassantVars = true } = props, rest = __rest(props, ["playerTurn", "board", "origin", "destination", "isSimulatedMove", "canSetEnPassantVars"]);
    let { isLastMoveVulnerableToEnPassant, enPassantCapturePieceIndex, pawnPromotionPieceIndex } = rest;
    let isValid = false;
    let boardUpdates = {};
    const multiplier = getPlayerMultiplier(playerTurn);
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const specialFirstMoveLowerBounds = playerTurn === "white" ? 6 * config_1.tilesPerRow : 1 * config_1.tilesPerRow;
    const specialFirstMoveUpperBounds = playerTurn === "white" ? 7 * config_1.tilesPerRow : 2 * config_1.tilesPerRow;
    const isNormalLeftCapture = origin + multiplier * config_1.tilesPerRow - 1 === destination && origin % config_1.tilesPerRow !== 0;
    const isNormalRightCapture = origin + multiplier * config_1.tilesPerRow + 1 === destination && origin % config_1.tilesPerRow !== config_1.tilesPerRow - 1;
    if (origin + multiplier * 2 * config_1.tilesPerRow === destination &&
        origin >= specialFirstMoveLowerBounds &&
        origin <= specialFirstMoveUpperBounds &&
        board[destination] === " " &&
        board[destination - multiplier * config_1.tilesPerRow] === " ") {
        // handle special first move
        isValid = true;
        if (canSetEnPassantVars) {
            isLastMoveVulnerableToEnPassant = true;
            enPassantCapturePieceIndex = destination;
        }
    }
    else if (origin + multiplier * config_1.tilesPerRow === destination && board[destination] === " ") {
        // handle normal move
        isValid = true;
        if (canSetEnPassantVars) {
            isLastMoveVulnerableToEnPassant = false;
            enPassantCapturePieceIndex = null;
        }
    }
    else if ((isNormalLeftCapture || isNormalRightCapture) && board[destination] !== " " && isDestinationFriendlyFree) {
        // handle normal left/right capture
        isValid = true;
        if (canSetEnPassantVars) {
            isLastMoveVulnerableToEnPassant = false;
            enPassantCapturePieceIndex = null;
        }
    }
    else if (isLastMoveVulnerableToEnPassant && enPassantCapturePieceIndex) {
        const isEnPassantLeftCapture = origin + multiplier * config_1.tilesPerRow - 1 === destination &&
            origin - 1 === enPassantCapturePieceIndex &&
            origin % config_1.tilesPerRow !== 0;
        const isEnPassantRightCapture = origin + multiplier * config_1.tilesPerRow + 1 === destination &&
            origin + 1 === enPassantCapturePieceIndex &&
            origin % config_1.tilesPerRow !== config_1.tilesPerRow - 1;
        if ((isEnPassantLeftCapture || isEnPassantRightCapture) &&
            board[destination] === " " &&
            board[enPassantCapturePieceIndex] === (playerTurn === "white" ? "p" : "P")) {
            // handle en passant left/right capture
            isValid = true;
            boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [enPassantCapturePieceIndex]: " " });
            if (canSetEnPassantVars) {
                isLastMoveVulnerableToEnPassant = false;
                enPassantCapturePieceIndex = null;
            }
        }
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "P" : "p" });
    }
    if (isValid && getCanPawnPromote(props)) {
        pawnPromotionPieceIndex = destination;
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, rest), { isValid,
        boardUpdates,
        isLastMoveVulnerableToEnPassant,
        enPassantCapturePieceIndex,
        pawnPromotionPieceIndex });
};
const getIsValidPawnMoveIgnoreEnPassant = (props) => {
    return getIsValidPawnMove(Object.assign(Object.assign({}, props), { canSetEnPassantVars: false }));
};
const getIsValidKnightMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false } = props;
    let isValid = false;
    let boardUpdates = {};
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const isKnightMove = (Math.abs(destination - origin) === 2 * config_1.tilesPerRow + 1 &&
        Math.abs((destination % config_1.tilesPerRow) - (origin % config_1.tilesPerRow)) === 1) ||
        (Math.abs(destination - origin) === 2 * config_1.tilesPerRow - 1 &&
            Math.abs((destination % config_1.tilesPerRow) - (origin % config_1.tilesPerRow)) === 1) ||
        (Math.abs(destination - origin) === config_1.tilesPerRow + 2 &&
            Math.abs((destination % config_1.tilesPerRow) - (origin % config_1.tilesPerRow)) === 2) ||
        (Math.abs(destination - origin) === config_1.tilesPerRow - 2 &&
            Math.abs((destination % config_1.tilesPerRow) - (origin % config_1.tilesPerRow)) === 2);
    const isKnightCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    if ((isDestinationFriendlyFree && isKnightMove) || (isDestinationFriendlyFree && isKnightMove && isKnightCapture)) {
        isValid = true;
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "N" : "n" });
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
};
const getIsValidBishopMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false } = props;
    let isValid = false;
    let boardUpdates = {};
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const isDiagonalMove = getIsDiagonalMove({ origin, destination });
    const isDiagonalClear = getIsDiagonalClear({ board, origin, destination });
    const isDiagonalCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    if ((isDestinationFriendlyFree && isDiagonalMove && isDiagonalClear) ||
        (isDestinationFriendlyFree && isDiagonalMove && isDiagonalClear && isDiagonalCapture)) {
        isValid = true;
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "B" : "b" });
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
};
const getIsValidRookMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false } = props;
    let isValid = false;
    let boardUpdates = {};
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const isStraightMove = getIsStraightMove({ origin, destination });
    const isStraightClear = getIsStraightClear({ board, origin, destination });
    const isStraightCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    if ((isDestinationFriendlyFree && isStraightMove && isStraightClear) ||
        (isDestinationFriendlyFree && isStraightMove && isStraightClear && isStraightCapture)) {
        isValid = true;
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "R" : "r" });
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
};
const getIsValidQueenMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false } = props;
    let isValid = false;
    let boardUpdates = {};
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const isDiagonalMove = getIsDiagonalMove({ origin, destination });
    const isDiagonalClear = getIsDiagonalClear({ board, origin, destination });
    const isDiagonalCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    if ((isDestinationFriendlyFree && isDiagonalMove && isDiagonalClear) ||
        (isDestinationFriendlyFree && isDiagonalMove && isDiagonalClear && isDiagonalCapture)) {
        isValid = true;
    }
    if (!isValid) {
        const isStraightMove = getIsStraightMove({ origin, destination });
        const isStraightClear = getIsStraightClear({ board, origin, destination });
        const isStraightCapture = getIsCapturingEnemyPiece({
            playerTurn,
            board,
            destination,
        });
        if ((isDestinationFriendlyFree && isStraightMove && isStraightClear) ||
            (isDestinationFriendlyFree && isStraightMove && isStraightClear && isStraightCapture)) {
            isValid = true;
        }
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "Q" : "q" });
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
};
const getIsValidKingMove = (props) => {
    const { playerTurn, board, origin, destination, isSimulatedMove = false, canSetCastlingVars = true } = props, rest = __rest(props, ["playerTurn", "board", "origin", "destination", "isSimulatedMove", "canSetCastlingVars"]);
    let { whiteKingHasMoved, whiteRightRookHasMoved, whiteLeftRookHasMoved, blackKingHasMoved, blackRightRookHasMoved, blackLeftRookHasMoved, } = rest;
    let isValid = false;
    let boardUpdates = {};
    if (playerTurn === "white" && origin === 60 && destination === 62 && getCanCastle(props)) {
        isValid = true;
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: "K", [61]: "R", [63]: " " });
        if (canSetCastlingVars) {
            whiteKingHasMoved = true;
            whiteRightRookHasMoved = true;
        }
    }
    else if (playerTurn === "white" && origin === 60 && destination === 58 && getCanCastle(props)) {
        isValid = true;
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: "K", [59]: "R", [56]: " " });
        if (canSetCastlingVars) {
            whiteKingHasMoved = true;
            whiteLeftRookHasMoved = true;
        }
    }
    else if (playerTurn === "black" && origin === 4 && destination === 6 && getCanCastle(props)) {
        isValid = true;
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: "k", [5]: "r", [7]: " " });
        if (canSetCastlingVars) {
            blackKingHasMoved = true;
            blackRightRookHasMoved = true;
        }
    }
    else if (playerTurn === "black" && origin === 4 && destination === 2 && getCanCastle(props)) {
        isValid = true;
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: "k", [3]: "r", [0]: " " });
        if (canSetCastlingVars) {
            blackKingHasMoved = true;
            blackLeftRookHasMoved = true;
        }
    }
    if (isValid) {
        return Object.assign(Object.assign({}, props), { whiteKingHasMoved,
            whiteRightRookHasMoved,
            whiteLeftRookHasMoved,
            blackKingHasMoved,
            blackRightRookHasMoved,
            blackLeftRookHasMoved,
            isValid,
            boardUpdates });
    }
    const isDestinationFriendlyFree = getIsDestinationFriendlyFree({
        playerTurn,
        board,
        destination,
    });
    const isDiagonalMove = getIsDiagonalMove({ origin, destination });
    const isDiagonalClear = getIsDiagonalClear({ board, origin, destination });
    const isDiagonalCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    const isStraightMove = getIsStraightMove({ origin, destination });
    const isStraightClear = getIsStraightClear({ board, origin, destination });
    const isStraightCapture = getIsCapturingEnemyPiece({
        playerTurn,
        board,
        destination,
    });
    const isOneTileMove = Math.abs(destination - origin) === config_1.tilesPerRow || // vertical move
        Math.abs(destination - origin) === 1 || // horizontal move
        Math.abs(destination - origin) === config_1.tilesPerRow - 1 || // diagonal move (up-left or up-right)
        Math.abs(destination - origin) === config_1.tilesPerRow + 1; // diagonal move (down-left or down-right)
    if ((isDestinationFriendlyFree && isDiagonalMove && isOneTileMove && isDiagonalClear) ||
        (isDestinationFriendlyFree && isDiagonalMove && isOneTileMove && isDiagonalClear && isDiagonalCapture) ||
        (isDestinationFriendlyFree && isStraightMove && isOneTileMove && isStraightClear) ||
        (isDestinationFriendlyFree && isStraightMove && isOneTileMove && isStraightClear && isStraightCapture)) {
        isValid = true;
    }
    if (isValid) {
        boardUpdates = Object.assign(Object.assign({}, boardUpdates), { [origin]: " ", [destination]: playerTurn === "white" ? "K" : "k" });
    }
    if (!isSimulatedMove) {
        const isInCheck = getWillMovePutKingInCheck(Object.assign(Object.assign({}, props), { boardUpdates }));
        if (isInCheck) {
            isValid = false;
            boardUpdates = {};
        }
    }
    return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
};
const getIsValidKingMoveIgnoreCastling = (props) => {
    return getIsValidKingMove(Object.assign(Object.assign({}, props), { canSetCastlingVars: false }));
};
const getIsValidMove = (props) => {
    const { piece } = props, rest = __rest(props, ["piece"]);
    const { playerTurn, origin, destination } = rest;
    const isValid = false;
    const boardUpdates = {};
    if (origin === destination) {
        return Object.assign(Object.assign({}, props), { isValid, boardUpdates });
    }
    let validMoveResponse = Object.assign(Object.assign({}, props), { isValid,
        boardUpdates });
    if (playerTurn === "white") {
        switch (piece) {
            case "P":
                validMoveResponse = getIsValidPawnMove(rest);
                break;
            case "N":
                validMoveResponse = getIsValidKnightMove(rest);
                break;
            case "B":
                validMoveResponse = getIsValidBishopMove(rest);
                break;
            case "R":
                validMoveResponse = getIsValidRookMove(rest);
                break;
            case "Q":
                validMoveResponse = getIsValidQueenMove(rest);
                break;
            case "K":
                validMoveResponse = getIsValidKingMove(rest);
                break;
        }
    }
    else {
        switch (piece) {
            case "p":
                validMoveResponse = getIsValidPawnMove(rest);
                break;
            case "n":
                validMoveResponse = getIsValidKnightMove(rest);
                break;
            case "b":
                validMoveResponse = getIsValidBishopMove(rest);
                break;
            case "r":
                validMoveResponse = getIsValidRookMove(rest);
                break;
            case "q":
                validMoveResponse = getIsValidQueenMove(rest);
                break;
            case "k":
                validMoveResponse = getIsValidKingMove(rest);
                break;
            default:
                break;
        }
    }
    return validMoveResponse;
};
exports.getIsValidMove = getIsValidMove;
const getKingPosition = ({ playerTurn, board }) => {
    let kingPosition = null;
    const kingPiece = playerTurn === "white" ? "K" : "k";
    for (let i = 0; i < config_1.totalTiles; i++) {
        if (board[i] === kingPiece) {
            kingPosition = i;
        }
    }
    if (kingPosition === null) {
        throw new Error("King not found");
    }
    return kingPosition;
};
const getIsKingInCheck = (props) => {
    const { playerTurn, board } = props;
    let isInCheck = false;
    const kingPosition = getKingPosition({ playerTurn, board });
    const opponentPlayerTurn = playerTurn === "white" ? "black" : "white";
    for (let i = 0; i < config_1.totalTiles; i++) {
        const { isValid } = getIsValidMove(Object.assign(Object.assign({}, props), { piece: board[i], playerTurn: opponentPlayerTurn, origin: i, destination: kingPosition, isSimulatedMove: true }));
        if (isValid) {
            isInCheck = true;
            break;
        }
    }
    return isInCheck;
};
exports.getIsKingInCheck = getIsKingInCheck;
const getWillMovePutKingInCheck = (props) => {
    const { board, boardUpdates } = props;
    return getIsKingInCheck(Object.assign(Object.assign({}, props), { board: getUpdatedBoardRepresentation({ board, boardUpdates }) }));
};
const getIsStalemate = (props) => {
    const { board } = props;
    let isStalemate = true;
    for (let i = 0; i < config_1.totalTiles; i++) {
        if (board[i] !== " ") {
            const validMoves = getAllValidPieceMoves(Object.assign(Object.assign({}, props), { piece: board[i], origin: i }));
            if (validMoves.length > 0) {
                isStalemate = false;
                break;
            }
        }
    }
    return isStalemate;
};
exports.getIsStalemate = getIsStalemate;
const getIsCheckmate = (props) => {
    return getIsKingInCheck(props) && getIsStalemate(props);
};
exports.getIsCheckmate = getIsCheckmate;
const getAllValidPieceMoves = (props) => {
    const { piece } = props, rest = __rest(props, ["piece"]);
    const { playerTurn } = rest;
    let validMovesFn = null;
    if ((playerTurn === "white" && !config_1.whiteSanPieces.includes(piece)) ||
        (playerTurn === "black" && !config_1.blackSanPieces.includes(piece))) {
        return [];
    }
    switch (piece) {
        case "P":
        case "p":
            validMovesFn = getIsValidPawnMoveIgnoreEnPassant;
            break;
        case "N":
        case "n":
            validMovesFn = getIsValidKnightMove;
            break;
        case "B":
        case "b":
            validMovesFn = getIsValidBishopMove;
            break;
        case "R":
        case "r":
            validMovesFn = getIsValidRookMove;
            break;
        case "Q":
        case "q":
            validMovesFn = getIsValidQueenMove;
            break;
        case "K":
        case "k":
            validMovesFn = getIsValidKingMoveIgnoreCastling;
            break;
        default:
            break;
    }
    let res = [];
    if (validMovesFn === null) {
        return res;
    }
    for (let i = 0; i < config_1.totalTiles; i++) {
        const { isValid } = validMovesFn(Object.assign(Object.assign({}, rest), { destination: i }));
        if (isValid) {
            res = [...res, i];
        }
    }
    return res;
};
exports.getAllValidPieceMoves = getAllValidPieceMoves;
const computeCanMakeMove = (props) => {
    const { piece, playerTurn, origin, destination } = props, rest = __rest(props, ["piece", "playerTurn", "origin", "destination"]);
    let { whiteKingHasMoved, whiteRightRookHasMoved, whiteLeftRookHasMoved, blackKingHasMoved, blackRightRookHasMoved, blackLeftRookHasMoved, } = rest;
    if (origin === destination ||
        (playerTurn === "white" && !config_1.whiteSanPieces.includes(piece)) ||
        (playerTurn === "black" && !config_1.blackSanPieces.includes(piece))) {
        return Object.assign(Object.assign({}, props), { isValid: false, boardUpdates: {} });
    }
    const res = getIsValidMove(props);
    if (res.isValid) {
        switch (origin) {
            case 0:
                blackRightRookHasMoved = true;
                break;
            case 7:
                blackLeftRookHasMoved = true;
                break;
            case 4:
                blackKingHasMoved = true;
                break;
            case 56:
                whiteLeftRookHasMoved = true;
                break;
            case 63:
                whiteRightRookHasMoved = true;
                break;
            case 60:
                whiteKingHasMoved = true;
                break;
            default:
                break;
        }
    }
    return Object.assign(Object.assign(Object.assign({}, props), res), { blackRightRookHasMoved,
        blackLeftRookHasMoved,
        blackKingHasMoved,
        whiteLeftRookHasMoved,
        whiteRightRookHasMoved,
        whiteKingHasMoved });
};
exports.computeCanMakeMove = computeCanMakeMove;
